import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eu4wj6o4ca: FaireBrandEntity = {
  token: "b_eu4wj6o4ca",
  type: "brand",
  name: "STATE The Label",
  avatarUrl:
    "https://cdn.faire.com/fastly/a67d83b6835648b8261103312338f61f124702029de7162ac29bf5ae3355002a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6bf5060e4692bfe85bbd8caf672b429b77e93e09e3b3dc80b6997f8f47811d81.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a67d83b6835648b8261103312338f61f124702029de7162ac29bf5ae3355002a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6bf5060e4692bfe85bbd8caf672b429b77e93e09e3b3dc80b6997f8f47811d81.jpeg",
  location: "Athens, GA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 31,
  isTopShop: true,
  isInsider: true,
  description:
    "The STATE aesthetic strikes an exciting balance between creativity and practicality, with the aim of making you feel inspired while comfortable.\nSTATE is headquartered in Athens, Georgia where we have a small, light-filled studio. \n\nThanks for being here.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:36:57.991Z",
    importedBy: "entity-db-cli",
  },
};
